import CardBenefitInformation from '../CardBenefitInformation/CardBenefitInformation';

import './FreeAccountPushForGuests.scss';

const FreeAccountPushForGuests = () => (
	<div className="FreeAccountPushForGuests">
		<CardBenefitInformation />
	</div>
);

export default FreeAccountPushForGuests;
